import React from 'react';
import { App, Button, Col, Form, Input, Popconfirm, Row, Select, Upload } from 'antd';
import { Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import InputLabel from 'components/InputLabel/index';
import { HolderOutlined, UploadOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { DEPLOYENVIRONMENT, FILE_PORT } from 'apiConfig';
import deleteIcon from 'assets/images/table-icons/delete_red.svg';
import viewIcon from 'assets/images/table-icons/view_blue.svg';
import pdfIcon from 'assets/images/icons/pdf_red.svg';
import { v4 as uuid } from 'uuid';
import { CSS } from '@dnd-kit/utilities';
import { closestCenter, DndContext } from '@dnd-kit/core';
import { SortableContext, useSortable } from '@dnd-kit/sortable';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
// import { useNavigate } from 'react-router-dom';
/**
 * AccountingInformation component renders the accounting information section
 * with form fields for the lease record management.
 *
 * This component should be rendered within a Form component context since it uses
 * Form.Item components that depend on the form context.
 *
 * @component
 * @param {Object} props - Component props
 * @param {string} props.screen - Current screen mode ('CREATE', 'EDIT', or 'VIEW')
 * @param {Object} props.constantFormValues - Form configuration values
 *
 * @returns {JSX.Element} The Accounting Information form section
 */
const AccountingInformation = ({ screen, constantFormValues, lynFormProperties, form }) => {
	const { message: messageApi } = App.useApp();
	const { accessToken } = useSelector((state) => state?.auth);
	// const [pdfList, setPdfList] = useState([]);
	// const [progress, setProgress] = useState(0);
	// const [uploading, setUploading] = useState(false);
	// const [status, setStatus] = useState('normal');
	// const navigate = useNavigate();

	// const customRequest = ({ file, onProgress, onSuccess, onError }) => {
	// 	const xhr = new XMLHttpRequest();
	// 	xhr.open('POST', `https://${DEPLOYENVIRONMENT}garlicerp.com:${FILE_PORT}/lynorg-service/endpoint/file/upload-awareness`);
	// 	xhr.setRequestHeader('token', `Bearer ${accessToken}`);
	// 	xhr.responseType = 'json';

	// 	// console.log('file', file);

	// 	xhr.upload.onprogress = ({ total, loaded }) => {
	// 		console.log('onProgress');
	// 		const percent = Math.round((loaded / total) * 100);
	// 		setProgress(percent);
	// 		onProgress({ percent });
	// 	};

	// 	xhr.onload = () => {
	// 		console.log('onLoad');
	// 		// setUploading(false);
	// 		if (xhr.status === 200) {
	// 			const res = xhr.response;
	// 			console.log('file', file);

	// 			const fileMeta = {
	// 				uid: file.uid,
	// 				name: file.name,
	// 				size: file.size,
	// 				type: file.type,
	// 				url: file.url,
	// 				lastModified: file.lastModified,
	// 			};

	// 			// message.success(`${file.name} uploaded successfully.`);
	// 			if (res) {
	// 				let fileURL = res?.fileURL;
	// 				let baseURL = `https://${DEPLOYENVIRONMENT}garlicerp.com/static/`;
	// 				let extension = '.pdf';
	// 				fileMeta.url = baseURL + fileURL + extension;
	// 			}
	// 			console.log('fileMeta', fileMeta);
	// 			uploadList(fileMeta);
	// 			onSuccess(res, file);
	// 			setStatus('success');
	// 		} else {
	// 			// message.error(`${file.name} upload failed.`);
	// 			onError(new Error('Upload failed'));
	// 			setStatus('exception');
	// 		}
	// 	};

	// 	xhr.onerror = () => {
	// 		console.log('onError');
	// 		// setUploading(false);
	// 		message.error(`${file.name} upload error.`);
	// 		onError(new Error('Upload error'));
	// 	};

	// 	const formData = new FormData();
	// 	formData.append('file', file);
	// 	xhr.send(formData);
	// 	setUploading(true);
	// };

	const getFileSize = (index) => {
		const fileJson = form.getFieldValue(['agreementFiles', index, 'file']);
		const file = fileJson ? JSON.parse(fileJson) : null;

		const bytes = file[0].size;

		if (file && bytes) {
			if (bytes === 0) return '0 Bytes';
			const k = 1024;
			const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
			const i = Math.floor(Math.log(bytes) / Math.log(k));
			const size = bytes / Math.pow(k, i);
			return `${size.toFixed(2)} ${sizes[i]}`;
		}
	};

	const beforeUpload = (file) => {
		const isPdf = file.type === 'application/pdf';
		if (!isPdf) {
			messageApi.error('You can only upload PDF files!');
			return Upload.LIST_IGNORE;
		}

		const isLt5M = file.size / 1024 / 1024 < 5;
		if (!isLt5M) {
			messageApi.error('File must be smaller than 5MB!');
			return Upload.LIST_IGNORE;
		}

		return true; // accept file
	};

	const handleDragEnd = (event, fields, fieldsOpt) => {
		const { active, over } = event;

		if (active?.id && over?.id && active?.id !== over?.id) {
			const oldIndex = fields.findIndex((field) => `${field.key}` === active.id);
			const newIndex = fields.findIndex((field) => `${field.key}` === over.id);

			// Update the state or form fields with reordered data
			fieldsOpt.move(oldIndex, newIndex);
		}
	};

	const uploadList = (file) => {
		const filesData = {
			id: uuid(),
			name: file.name.replace('.pdf', ''),
			file: JSON.stringify([file]),
		};

		const existFiles = form.getFieldValue('agreementFiles');
		if (existFiles) {
			form.setFieldsValue({ agreementFiles: [...existFiles, filesData] });
		} else {
			form.setFieldsValue({ agreementFiles: [filesData] });
		}
	};

	const pdfUploadHandler = ({ file }) => {
		const { status } = file;
		if (status === 'done') {
			if (file?.response) {
				let fileURL = file?.response?.fileURL;
				let baseURL = `https://${DEPLOYENVIRONMENT}garlicerp.com/static/`;
				let extension = '.pdf';
				file.url = baseURL + fileURL + extension;
			}
			uploadList(file);
		} else if (status === 'error') {
			messageApi.error(`${file.name} file upload failed.`);
		}
	};
	const pdfReUploadHandler = ({ file }, index, previousFile) => {
		// console.log('previousFile', previousFile);
		// console.log('index', index);

		const { status } = file;
		if (status === 'done') {
			if (file?.response) {
				let fileURL = file?.response?.fileURL;
				let baseURL = `https://${DEPLOYENVIRONMENT}garlicerp.com/static/`;
				let extension = '.pdf';
				file.url = baseURL + fileURL + extension;
			}
			const filesData = {
				id: previousFile?.id,
				name: previousFile?.name,
				file: JSON.stringify([file]),
			};

			const existFiles = form.getFieldValue('deletedFiles');
			if (existFiles) {
				form.setFieldsValue({ deletedFiles: [...existFiles, previousFile] });
			} else {
				form.setFieldsValue({ deletedFiles: [previousFile] });
			}
			// const existFiles = form.getFieldValue('agreementFiles');
			// if (existFiles) {
			// 	form.setFieldsValue({ agreementFiles: [...existFiles, filesData] });
			// } else {
			form.setFieldValue(['agreementFiles', index], filesData);
			// }
		} else if (status === 'error') {
			messageApi.error(`${file.name} file upload failed.`);
		}
	};

	const onPreviewHandler = (id) => {
		// navigate(`/modules/LMS/doc-hub?nodeId=${id}`);
		window.open(`/modules/LMS/doc-hub?nodeId=${id}`, '_blank');
	};

	const uploadComponentProps = {
		name: 'file',
		multiple: true,
		headers: { token: `Bearer ${accessToken}` },
		action: `https://${DEPLOYENVIRONMENT}file.garlicerp.com:${FILE_PORT}/lynorg-service/endpoint/file/upload-awareness`,
		showUploadList: false,
		accept: '.pdf',
		// listType: 'picture',
		className: 'upload-list-inline',
	};

	return (
		<>
			<Row gutter={[16, 0]}>
				<Col xs={4}>
					<InputLabel label={constantFormValues?.rightOfUseAssetValue?.label} head={true} />
				</Col>
				<Col xs={8}>
					<Form.Item name={constantFormValues?.rightOfUseAssetValue?.key}>
						<Select
							disabled={screen === 'VIEW'}
							showSearch
							// allowClear
							style={{ width: '100%', height: '32px' }}
							filterOption={true}
							placeholder="Select from the list"
						>
							{lynFormProperties?.rightOfUseAssetValue?.map(({ id, displayName }) => (
								<Select.Option key={id} value={displayName}>
									{displayName}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
					{/* <NonDependantSelect name="rightOfUseAssetValue" code="PROPERTY_rightOfUseAssetValue" processCode={state?.processCode} /> */}
				</Col>
				<Col xs={4}>
					<InputLabel label={constantFormValues?.glleaseLiability?.label} head={true} />
				</Col>
				<Col xs={8}>
					<Form.Item name={constantFormValues?.glleaseLiability?.key} rules={constantFormValues?.glleaseLiability?.rules}>
						<Select
							disabled={screen === 'VIEW'}
							showSearch
							// allowClear
							style={{ width: '100%', height: '32px' }}
							filterOption={true}
							placeholder="Select from the list"
						>
							{lynFormProperties?.glleaseLiability?.map(({ id, displayName }) => (
								<Select.Option key={id} value={displayName}>
									{displayName}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
				</Col>

				<Col xs={4}>
					<InputLabel label={constantFormValues?.costCenterInterestExpense?.label} head={true} />
				</Col>
				<Col xs={8}>
					<Form.Item name={constantFormValues?.costCenterInterestExpense?.key} rules={constantFormValues?.costCenterInterestExpense?.rules}>
						<Select
							disabled={screen === 'VIEW'}
							showSearch
							// allowClear
							style={{ width: '100%', height: '32px' }}
							filterOption={true}
							placeholder="Select from the list"
						>
							{lynFormProperties?.costCenterInterestExpense?.map(({ id, displayName }) => (
								<Select.Option key={id} value={displayName}>
									{displayName}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
				</Col>
				<Col xs={4}>
					<InputLabel label={constantFormValues?.glInterestExpense?.label} head={true} />
				</Col>
				<Col xs={8}>
					<Form.Item name={constantFormValues?.glInterestExpense?.key} rules={constantFormValues?.glInterestExpense?.rules}>
						<Select
							disabled={screen === 'VIEW'}
							showSearch
							// allowClear
							style={{ width: '100%', height: '32px' }}
							filterOption={true}
							placeholder="Select from the list"
						>
							{lynFormProperties?.glInterestExpense?.map(({ id, displayName }) => (
								<Select.Option key={id} value={displayName}>
									{displayName}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
				</Col>

				<Col xs={4}>
					<InputLabel label={constantFormValues?.leaseExpenseCostCenter?.label} head={true} />
				</Col>
				<Col xs={8}>
					<Form.Item name={constantFormValues?.leaseExpenseCostCenter?.key} rules={constantFormValues?.leaseExpenseCostCenter?.rules}>
						<Select
							disabled={screen === 'VIEW'}
							showSearch
							// allowClear
							style={{ width: '100%', height: '32px' }}
							filterOption={true}
							placeholder="Select from the list"
						>
							{lynFormProperties?.leaseExpenseCostCenter?.map(({ id, displayName }) => (
								<Select.Option key={id} value={displayName}>
									{displayName}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
				</Col>
				<Col xs={4}>
					<InputLabel label={constantFormValues?.leaseExpense?.label} head={true} />
				</Col>
				<Col xs={8}>
					<Form.Item name={constantFormValues?.leaseExpense?.key} rules={constantFormValues?.leaseExpense?.rules}>
						<Select
							disabled={screen === 'VIEW'}
							showSearch
							// allowClear
							style={{ width: '100%', height: '32px' }}
							filterOption={true}
							placeholder="Select from the list"
						>
							{lynFormProperties?.leaseExpense?.map(({ id, displayName }) => (
								<Select.Option key={id} value={displayName}>
									{displayName}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
				</Col>

				<Col xs={4}>
					<InputLabel label={constantFormValues?.leasePayableControlAccount?.label} head={true} />
				</Col>
				<Col xs={8}>
					<Form.Item
						name={constantFormValues?.leasePayableControlAccount?.key}
						rules={constantFormValues?.leasePayableControlAccount?.rules}
					>
						<Select
							disabled={screen === 'VIEW'}
							showSearch
							// allowClear
							style={{ width: '100%', height: '32px' }}
							filterOption={true}
							placeholder="Select from the list"
						>
							{lynFormProperties?.leasePayableControlAccount?.map(({ id, displayName }) => (
								<Select.Option key={id} value={displayName}>
									{displayName}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
				</Col>
				<Col xs={4}>
					<InputLabel label={constantFormValues?.glAdvanceRent?.label} head={true} />
				</Col>
				<Col xs={8}>
					<Form.Item name={constantFormValues?.glAdvanceRent?.key} rules={constantFormValues?.glAdvanceRent?.rules}>
						<Select
							disabled={screen === 'VIEW'}
							showSearch
							// allowClear
							style={{ width: '100%', height: '32px' }}
							filterOption={true}
							placeholder="Select from the list"
						>
							{lynFormProperties?.glAdvanceRent?.map(({ id, displayName }) => (
								<Select.Option key={id} value={displayName}>
									{displayName}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
				</Col>

				<Col xs={4}>
					<InputLabel label={constantFormValues?.depreciationRoUCostCenter?.label} head={true} />
				</Col>
				<Col xs={8}>
					<Form.Item name={constantFormValues?.depreciationRoUCostCenter?.key} rules={constantFormValues?.depreciationRoUCostCenter?.rules}>
						<Select
							disabled={screen === 'VIEW'}
							showSearch
							// allowClear
							style={{ width: '100%', height: '32px' }}
							filterOption={true}
							placeholder="Select from the list"
						>
							{lynFormProperties?.depreciationRoUCostCenter?.map(({ id, displayName }) => (
								<Select.Option key={id} value={displayName}>
									{displayName}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
				</Col>
				<Col xs={4}>
					<InputLabel label={constantFormValues?.depreciationRoU?.label} head={true} />
				</Col>
				<Col xs={8}>
					<Form.Item name={constantFormValues?.depreciationRoU?.key} rules={constantFormValues?.depreciationRoU?.rules}>
						<Select
							disabled={screen === 'VIEW'}
							showSearch
							// allowClear
							style={{ width: '100%', height: '32px' }}
							filterOption={true}
							placeholder="Select from the list"
						>
							{lynFormProperties?.depreciationRoU?.map(({ id, displayName }) => (
								<Select.Option key={id} value={displayName}>
									{displayName}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
				</Col>

				<Col xs={4}>
					<InputLabel label={constantFormValues?.accumDepreciationRoU?.label} head={true} />
				</Col>
				<Col xs={8}>
					<Form.Item name={constantFormValues?.accumDepreciationRoU?.key} rules={constantFormValues?.accumDepreciationRoU?.rules}>
						<Select
							disabled={screen === 'VIEW'}
							showSearch
							// allowClear
							style={{ width: '100%', height: '32px' }}
							filterOption={true}
							placeholder="Select from the list"
						>
							{lynFormProperties?.accumDepreciationRoU?.map(({ id, displayName }) => (
								<Select.Option key={id} value={displayName}>
									{displayName}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
				</Col>
				<Col xs={4}>
					<InputLabel label={constantFormValues?.glBankAccount?.label} head={true} />
				</Col>
				<Col xs={8}>
					<Form.Item name={constantFormValues?.glBankAccount?.key} rules={constantFormValues?.glBankAccount?.rules}>
						<Select
							disabled={screen === 'VIEW'}
							showSearch
							// allowClear
							style={{ width: '100%', height: '32px' }}
							filterOption={true}
							placeholder="Select from the list"
						>
							{lynFormProperties?.glBankAccount?.map(({ id, displayName }) => (
								<Select.Option key={id} value={displayName}>
									{displayName}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
				</Col>

				<Col xs={4}>
					<InputLabel label={constantFormValues?.securityDepositHead?.label} head={true} />
				</Col>
				<Col xs={8}>
					<Form.Item name={constantFormValues?.securityDepositHead?.key} rules={constantFormValues?.securityDepositHead?.rules}>
						<Select
							disabled={screen === 'VIEW'}
							showSearch
							// allowClear
							style={{ width: '100%', height: '32px' }}
							filterOption={true}
							placeholder="Select from the list"
						>
							{lynFormProperties?.securityDepositHead?.map(({ id, displayName }) => (
								<Select.Option key={id} value={displayName}>
									{displayName}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
				</Col>
				<Col xs={4}>
					<InputLabel label={constantFormValues?.accountsPayableHead?.label} head={true} />
				</Col>
				<Col xs={8}>
					<Form.Item name={constantFormValues?.accountsPayableHead?.key} rules={constantFormValues?.accountsPayableHead?.rules}>
						<Select
							disabled={screen === 'VIEW'}
							showSearch
							// allowClear
							style={{ width: '100%', height: '32px' }}
							filterOption={true}
							placeholder="Select from the list"
						>
							{lynFormProperties?.accountsPayableHead?.map(({ id, displayName }) => (
								<Select.Option key={id} value={displayName}>
									{displayName}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
				</Col>
				<Form.List name="deletedFiles" noStyle>
					{(fields) => fields.map((field) => <Form.Item key={field.key} name={[field.name, 'id']} noStyle />)}
				</Form.List>
				<Form.List name="agreementFiles">
					{(fields, fieldsOpt) => (
						<>
							{screen?.toLocaleLowerCase() !== 'view' && (
								<>
									<Col xs={4}>
										<InputLabel label="Agreement File" head={true} />
									</Col>
									<Col xs={4}>
										<Upload {...uploadComponentProps} onChange={pdfUploadHandler}>
											<Button icon={<UploadOutlined />}>Upload</Button>
										</Upload>
									</Col>
								</>
							)}
							<Col xs={24}>
								{/* <TableContainer
									className="render-condition"
									sx={{
										'& table, & th, & td': {
											border: '1px solid #e0e0e0',
											borderCollapse: 'collapse',
										},
										'& th, & td': {
											p: '5px',
										},
										'& td .ant-form-item': {
											marginBottom: '0px',
										},
										'& .condition-msg': {
											py: 3,
										},
									}}
								>
									<Table aria-label="renderConditions table">
										<TableHead>
											<TableRow>
												<TableCell>Attachment Title</TableCell>
												// <TableCell align="center">Attachment</TableCell>
												<TableCell align="center">Action</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											{fields?.length > 0 ? (
												fields.map((field) => (
													<TableRow key={field.key}>
														<TableCell align="center">
															<Form.Item name={[field.name, 'id']} noStyle />
															<Form.Item name={[field.name, 'file']} noStyle />
															<Form.Item name={[field.name, 'name']} rules={[{ required: true }]}>
																<Input
																	disabled={screen?.toLocaleLowerCase() === 'view' ? true : false}
																	placeholder="Write here"
																/>
															</Form.Item>
														</TableCell>
														// <TableCell>
														// 	<Upload
														// 		name="file"
														// 		showUploadList={{
														// 			showDownloadIcon: false,
														// 			showRemoveIcon: false,
														// 		}}
														// 		listType="text"
														// 		fileList={pdfList[index] ? pdfList[index] : []}
														// 		className="upload-list-inline"
														// 	/>
														// </TableCell>
														<TableCell align="center">
															{screen?.toLocaleLowerCase() === 'view' ? (
																<Button
																	type="primary"
																	onClick={() =>
																		onPreviewHandler(form.getFieldValue(['agreementFiles', field.name, 'id']))
																	}
																	style={{ marginRight: '5px' }}
																>
																	Preview
																</Button>
															) : (
																<Button danger type="primary" onClick={() => fieldsOpt.remove(field.name)}>
																	Delete
																</Button>
															)}
														</TableCell>
													</TableRow>
												))
											) : (
												<TableRow>
													<TableCell colSpan="3" align="center" className="condition-msg">
														Click Upload Button to add Attachment
													</TableCell>
												</TableRow>
											)}
										</TableBody>
									</Table>
								</TableContainer> */}
								<DndContext
									collisionDetection={closestCenter}
									onDragEnd={(e) => handleDragEnd(e, fields, fieldsOpt)}
									modifiers={[restrictToVerticalAxis]}
								>
									<TableContainer
										className="render-condition"
										sx={{
											'& table, & th, & td': {
												border: '1px solid #e0e0e0',
												borderCollapse: 'collapse',
											},
											'& th': {
												py: '5px',
												px: '11px',
											},
											'& td': {
												p: '5px',
											},
											'& td .ant-form-item': {
												marginBottom: '0px',
											},
											'& .condition-msg': {
												py: 3,
											},
											overflow: 'hidden',
										}}
									>
										<Table aria-label="renderConditions table">
											<TableHead>
												<TableRow>
													{screen?.toLocaleLowerCase() !== 'view' && <TableCell></TableCell>}
													<TableCell>Attachment Title</TableCell>
													<TableCell align="center">File</TableCell>
													<TableCell align="center">Action</TableCell>
												</TableRow>
											</TableHead>
											<TableBody>
												{fields.length > 0 ? (
													fields.map((field) => (
														<SortableContext key={field.key} items={fields.map((field) => `${field.key}`)}>
															<SortableItem id={`${field.key}`} screen={screen}>
																<TableCell align="center">
																	<Form.Item name={[field.name, 'id']} noStyle />
																	<Form.Item name={[field.name, 'file']} noStyle />
																	<Form.Item name={[field.name, 'name']} rules={[{ required: true }]}>
																		<Input
																			disabled={screen?.toLocaleLowerCase() === 'view'}
																			placeholder="Write here"
																		/>
																	</Form.Item>
																</TableCell>
																<TableCell align="center">
																	{/* <CheckCircleFilled
																		style={{
																			color: '#52c41a',
																			fontSize: '16px',
																		}}
																	/> */}
																	<Stack direction="column" justifyContent="center" alignItems="center" spacing={1}>
																		<img
																			src={pdfIcon}
																			alt="pdf"
																			width={18}
																			height={18}
																			// style={{ marginRight: '8px' }}
																		/>
																		<Typography component="span" style={{ fontSize: '12px' }}>
																			{getFileSize(field.name)}
																		</Typography>
																	</Stack>
																</TableCell>
																<TableCell align="center">
																	{screen?.toLocaleLowerCase() === 'view' && (
																		<Button
																			title="Preview"
																			onClick={() =>
																				onPreviewHandler(
																					form.getFieldValue(['agreementFiles', field.name, 'id'])
																				)
																			}
																			style={{ marginRight: '5px' }}
																		>
																			<img src={viewIcon} width={16} height={16} alt="edit" />
																		</Button>
																	)}
																	{screen?.toLocaleLowerCase() === 'edit' && (
																		<Upload
																			name="file"
																			multiple={false}
																			headers={{ token: `Bearer ${accessToken}` }}
																			action={`https://${DEPLOYENVIRONMENT}file.garlicerp.com:${FILE_PORT}/lynorg-service/endpoint/file/upload-awareness`}
																			showUploadList={false}
																			accept=".pdf"
																			beforeUpload={beforeUpload}
																			// customRequest={customRequest(info)}
																			onChange={(file) =>
																				pdfReUploadHandler(
																					file,
																					field.name,
																					form.getFieldValue(['agreementFiles', field.name])
																				)
																			}
																		>
																			<Button title="Re-Upload" style={{ marginRight: '5px' }}>
																				<UploadOutlined />
																			</Button>
																		</Upload>
																	)}
																	{(screen?.toLocaleLowerCase() === 'edit' ||
																		screen?.toLocaleLowerCase() === 'create') && (
																		<Popconfirm
																			title="Delete the attachment"
																			description="Are you sure to delete this attachment?"
																			okText="Yes"
																			cancelText="No"
																			onConfirm={() => {
																				if (screen?.toLocaleLowerCase() === 'edit') {
																					const file = form.getFieldValue(['agreementFiles', field.name]);
																					const deletedFileRange = form.getFieldValue('deletedFiles') ?? [];
																					const payload = [...deletedFileRange, file];
																					form.setFieldsValue({ deletedFiles: payload });
																				}
																				fieldsOpt.remove(field.name);
																			}}
																		>
																			<Button title="Delete">
																				<img src={deleteIcon} width={16} height={16} alt="edit" />
																			</Button>
																		</Popconfirm>
																	)}
																</TableCell>
															</SortableItem>
														</SortableContext>
													))
												) : (
													<TableRow>
														<TableCell colSpan="4" align="center" className="condition-msg">
															Click Upload Button to add Attachment
														</TableCell>
													</TableRow>
												)}
											</TableBody>
										</Table>
									</TableContainer>
								</DndContext>
							</Col>
						</>
					)}
				</Form.List>
			</Row>
			{/* <Dialog
				fullWidth={true}
				maxWidth={'sm'}
				open={showModal}
				keepMounted
				onClose={() => setShowModal(false)}
				aria-labelledby="draggable-dialog-title"
				sx={{ '& .MuiPaper-root': { borderRadius: '8px' } }}
			>
				<Box>
					<Grid container spacing={2} justifyContent="space-between" alignItems="center" sx={{ bgcolor: '#214689' }}>
						<Grid item>
							<Typography variant="subtitle2" sx={{ cursor: 'pointer', color: 'white', pl: '15px', pr: '5px' }} onClick={() => {}}>
								Click here <DownloadOutlined style={{ fontSize: '18px', color: 'white', margin: '0 5px' }} /> to download PDF
							</Typography>
						</Grid>

						<Grid item>
							<CloseOutlined style={{ bdcolor: 'white', color: 'white', padding: '15px' }} onClick={() => setShowModal(false)} />
						</Grid>
					</Grid>
				</Box>
			</Dialog> */}
		</>
	);
};

export default AccountingInformation;

function SortableItem({ id, children, screen }) {
	const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

	const style = {
		transform: CSS.Transform.toString(transform),
		transition,
		// background: '#fff',
		zIndex: 1,
		position: 'relative',
	};

	return (
		<TableRow ref={setNodeRef} style={style} {...attributes}>
			{screen?.toLocaleLowerCase() !== 'view' && (
				<TableCell align="center" sx={{ cursor: 'grab' }} {...listeners}>
					<HolderOutlined />
				</TableCell>
			)}
			{children}
		</TableRow>
	);
}
